import angular from 'angular';
import { SharedAngular } from '@Client/@types/sharedAngular';
import IPublishRequestOverview from '@Shared.Angular/@types/core/contracts/queryModel/governance/publishRequestOverview';
import IReviewDueOverview from '@Shared.Angular/@types/core/contracts/queryModel/governance/reviewDueOverview';
import PublishRequestFilter from '@Shared.Angular/@types/core/contracts/constants/publishRequestFilter';

export default class GovernanceApiService {
  public static $inject = ['$http', 'APP_CONFIG', 'runnerStartFlowsFormatter'];

  constructor(
    private $http: angular.IHttpService,
    private APP_CONFIG: SharedAngular.APP_CONFIG,
    private runnerStartFlowsFormatter: RunnerStartFlowsFormatter
  ) {}

  public getGovernanceHasContent() {
    return this.$http
      .get<boolean>(this.APP_CONFIG.apiBaseUrl + 'governance')
      .then((response) => {
        return response.data;
      });
  }

  public getPublishRequests(filter: PublishRequestFilter, noSpinner = false) {
    return this.$http
      .get<IPublishRequestOverview[]>(
        this.APP_CONFIG.apiBaseUrl + 'governance/publishRequests',
        {
          noSpinner: noSpinner,
          params: {
            filter: filter
          }
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  public getReviewDueItems(noSpinner: boolean) {
    return this.$http
      .get<IReviewDueOverview[]>(
        this.APP_CONFIG.apiBaseUrl + 'governance/reviewdue/v2',
        {
          noSpinner: noSpinner
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  public getCategorizedPublishRequests(
    filter: PublishRequestFilter,
    noSpinner = false
  ) {
    return this.getPublishRequests(filter, noSpinner)
      .then((flowModels) =>
        this.runnerStartFlowsFormatter.groupObjectsByCategory(
          flowModels,
          function (category) {
            category.subCategories?.forEach((subCategory) => subCategory);
          }
        )
      )
      .catch(() => {
        return [];
      });
  }

  public getCategorizedReviewDueItems(noSpinner = false) {
    return this.getReviewDueItems(noSpinner)
      .then((reviewDueItems) =>
        this.runnerStartFlowsFormatter.groupObjectsByCategory(
          reviewDueItems,
          function (category) {
            category.subCategories?.forEach((subCategory) => subCategory);
          }
        )
      )
      .catch(() => {
        return [];
      });
  }
}

angular
  .module('flowingly.runner.services')
  .service('governanceApiService', GovernanceApiService);

export type GovernanceApiServiceType = InstanceType<
  typeof GovernanceApiService
>;
